<template>
  <div class="tags-view-container">
      <el-tabs v-model="editableTabsValue" class="tags-view-wrapper" v-if="tabsShow&&isAdmin">
        <el-tab-pane v-for="(tag,index) in tabViews" ref="tag" :key="tag.path+index">
            <div slot="label"
              :title="tag.title.length>4?tag.title:''"
              :style="{'width': width+'px'}"
              ref="tag"
              :class="['tags-view-item',{'active':isActive(tag)}, tag.customClass || '']"
              @click="activeTag(tag)"
              @dblclick.prevent="refreshSelectedTag(tag,index)"
              @contextmenu.prevent="openMenu(tag,$event,index)">
              <span class="name">{{tag.title}}</span>
              <span v-show="refreshViewIndex!==index" class="el-icon-close close" @click.prevent.stop="closeSelectedTag(tag,index)" :class="isActive(tag)?'close-active':''"/>
              <span v-show="refreshViewIndex===index" class=" el-icon-refresh refresh"/>
            </div>
        </el-tab-pane>
      </el-tabs>
      <el-tabs v-model="editableTabsValue" class="tags-view-wrapper" v-if="tabsShow&&!isAdmin">
          <el-tab-pane v-for="(tag,index) in tabViews" ref="tag" :key="tag.path+index">
            <div v-if="index===0" slot="label" :class="[isActive(homePage)?'active':'', tag.customClass || '', tag.name === 'ProcessDoingtasks' && todoProcessNum>0 ? 'cancle-center' : 'index']" name="index" @click='activeTag(homePage,"index")' class="tags-view-item">
            主页
            <el-badge v-show="tag.name === 'ProcessDoingtasks' && todoProcessNum > 0" :value="todoProcessNum" :max="99" :class="['badge-homepage', todoProcessNum > 99 ? 'badge-homepage-more' : '']"></el-badge>
            </div>
            <div v-else slot="label"
              :title="tag.title.length>4?tag.title:''"
              :style="{'width': width+'px'}"
              ref="tag"
              :class="['tags-view-item',{'active':isActive(tag)}, tag.customClass || '']"
              @click="activeTag(tag)"
              @dblclick.prevent="refreshSelectedTag(tag,index)"
              @contextmenu.prevent="openMenu(tag,$event,index)">
              <span class="name">{{tag.title}}</span>
              <span v-show="refreshViewIndex!==index" class="el-icon-close close" @click.prevent.stop="closeSelectedTag(tag,index)" :class="isActive(tag)?'close-active':''"/>
              <span v-show="refreshViewIndex===index" class=" el-icon-refresh refresh"/>
            </div>
        </el-tab-pane>
    </el-tabs>
    <ul v-show="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
      <li @click="closeSelectedTag">关闭当前标签页</li>
      <li :class="{'disabled':hasOtherTabs}" @click="closeOthersTags">关闭其他标签页</li>
      <li :class="{'disabled':hasLeftTabs}" @click="closeLeftAllTags">关闭左侧标签页</li>
      <li :class="{'disabled':hasRightTabs}" @click="closeRightAllTags">关闭右侧标签页</li>
      <li @click="refreshSelectedTag(selectedTag,selectedTagIndex)">刷新当前标签页</li>
      <li @click="closeAllTags">关闭全部</li>
    </ul>
  </div>
</template>

<script>

export default {
  name: 'TagsView',
  props: ['menuHideleft', 'cachedViews', 'menuIds', 'currentMenuId', 'headerMenu', 'todoProcessNum'],
  data () {
    return {
      editableTabsValue: '0',
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      selectedTagIndex: -1,
      tabViews: [],
      refreshViewIndex: -1,
      allMenuIds: [],
      homePage: {},
      tabsShow: false,
      isAdmin: JSON.parse(sessionStorage.getItem('admin'))
    }
  },
  watch: {
    '$route' () {
      this.addTags()
    },
    visible (value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  computed: {
    width () {
      return (document.body.scrollWidth - this.menuHideleft - 130) / this.tabViews.length
    },
    hasRightTabs () {
      let index = this.tabViews.findIndex(n => n.id === this.selectedTag.id)
      return index === this.tabViews.length - 1
    },
    hasLeftTabs () {
      let index = this.tabViews.findIndex(n => n.id === this.selectedTag.id)
      return index === 1
    },
    hasOtherTabs () {
      return this.tabViews.length < 3
    }
  },
  methods: {
    setCachedViews (tabViews) {
      this.$emit('setCachedViews', tabViews)
    },
    setCachedHomePage (tabViews) {
      this.$emit('firstEntry', tabViews)
    },
    setCurrentId (currentId) {
      this.$emit('setCurrentId', currentId)
    },
    findFirstReportName (headerMenu, id) {
      if (headerMenu.id === id) {
        return headerMenu
      }
      for (const item of headerMenu.children) {
        let restlt = this.findFirstReportName(item, id)
        if (restlt) {
          return restlt
        }
      }
    },
    addTags () {
      // 如果是群组首页就跳到首页
      let homePage = JSON.parse(sessionStorage.getItem('homepage'))
      let homePath = `/main${homePage[0].path}`
      let tabsMenuIds = this.tabViews.map(m => m.id)
      if (this.$route.path === homePath) {
        this.homePage = homePage[0]
        this.homePage.path = '/main' + homePage[0].path
        if (!tabsMenuIds.includes(this.homePage.id)) {
          this.tabViews = homePage
          // 为了解决作为主页的报表 多个报表公用一个菜单链接
          this.tabViews.forEach(m => {
            if (m.name.includes('ReportRuntime') || m.name.includes('FormRuntime')) {
              m.reportId = m.path.split('/').pop()
            }
          })
          this.setCachedHomePage(this.tabViews)
        }
        this.tabsShow = true
        return
      }
      let tabName = this.findFirstReportName({children: this.headerMenu}, this.currentMenuId) && this.findFirstReportName({children: this.headerMenu}, this.currentMenuId).name
      this.allMenuIds = this.menuIds.length !== 0 ? this.menuIds : sessionStorage.getItem('menuIds')
      if (this.allMenuIds && this.allMenuIds.includes(this.currentMenuId) && tabName && !tabsMenuIds.includes(this.currentMenuId) && this.$route.name !== 'index') {
        let tag = {
          id: this.currentMenuId,
          name: this.$route.name,
          title: tabName,
          path: this.$route.path,
          fullPath: this.$route.fullPath,
          query: this.$route.query,
          params: this.$route.params
        }
        // 为了解决多个报表公用一个菜单链接(共用的话链接中报表id是一致，还是菜单的id不一样，所有用一个reportId做区别)
        // 表单标签页
        if (this.$route.name.includes('ReportRuntime') || this.$route.name.includes('FormRuntime')) {
          let array = tag.path.split('/')
          tag.reportId = array.pop()
        }

        let tabsMenuReportIds = this.tabViews.map(m => m.reportId)
        if (tag.reportId && tabsMenuReportIds.includes(tag.reportId)) {
          return false
        }
        this.tabViews.push(tag)
        // 需要缓存的
        if (this.cachedViews.includes(this.$route.name)) {
          this.tabsShow = true
          return
        }
        this.setCachedViews(this.tabViews)
        this.tabsShow = true
      }
      // 路由跳转的定制事件
      this.$emit('activeTagEvent', this.currentMenuId)
    },
    isActive (route) {
      return route.path === this.$route.path
    },

    refreshSelectedTag (view, index) {
      this.$router.push({name: 'Noting'})
      const { fullPath } = view
      this.refreshViewIndex = index
      let tabViews = this.$_.cloneDeep(this.tabViews)
      tabViews.splice(index, 1)
      this.setCachedViews(tabViews)
      setTimeout(() => {
        this.$router.replace({
          path: fullPath
        })
        tabViews.splice(index, 0, view)
        this.setCachedViews(tabViews)
        this.refreshViewIndex = -1
      }, 600)
    },
    activeTag (tag, index) {
      let homePage = JSON.parse(sessionStorage.getItem('homepage'))
      let homePath = `/main${homePage[0].path}`
      if (index) {
        this.$router.push({path: homePath})
      } else {
        this.$router.push({path: tag.path,
          params: tag.params,
          query: tag.query})
        this.selectedTag = tag
        this.setCurrentId(this.selectedTag.id)
      }
    },

    closeSelectedTag (view, index) {
      this.tabsShow = false
      let viewIndex
      if (index || index === 0) {
        viewIndex = index
      } else {
        viewIndex = this.tabViews.findIndex(n => n.path === this.selectedTag.path)
      }
      this.tabViews.splice(viewIndex, 1)
      this.setCachedViews(this.tabViews)
      if (this.isActive(view) || this.isActive(this.selectedTag)) {
        this.toLastView(this.tabViews)
      }
      this.$nextTick(() => {
        this.tabsShow = true
      })
    },
    closeLeftAllTags () {
      this.$router.push(this.selectedTag)
      let viewIndex = this.tabViews.findIndex(n => n.path === this.selectedTag.path)
      this.tabViews = this.tabViews.filter((v, index) => index >= viewIndex || index === 0)
      this.setCurrentId(this.selectedTag.id)
      this.setCachedViews(this.tabViews)
    },
    closeRightAllTags () {
      this.$router.push(this.selectedTag)
      let viewIndex = this.tabViews.findIndex(n => n.path === this.selectedTag.path)
      this.tabViews = this.tabViews.filter((v, index) => index <= viewIndex)
      this.setCurrentId(this.selectedTag.id)
      this.setCachedViews(this.tabViews)
    },
    closeOthersTags () {
      this.$router.push(this.selectedTag)
      this.tabViews = this.tabViews.filter((v, index) => {
        return v.path === this.selectedTag.path || index === 0
      })
      this.setCurrentId(this.selectedTag.id)
      this.setCachedViews(this.tabViews)
    },
    closeAllTags (view) {
      this.tabViews = [this.tabViews[0]]
      this.setCachedViews(this.tabViews)
      this.$router.push({ name: 'index' })
    },
    toLastView (tabViews) {
      const latestView = tabViews.slice(-1)[0]
      if (latestView) {
        this.$router.push({
          path: latestView.path,
          params: latestView.params,
          query: latestView.query
        })
        this.setCurrentId(latestView.id)
      } else {
        this.$router.push({ name: 'index' })
        this.editableTabsValue = 'index'
      }
    },
    delLastTagView () {
      this.tabViews.splice(this.tabViews.length - 1, 1)
      this.setCachedViews(this.tabViews)
      this.toLastView(this.tabViews)
    },
    openMenu (tag, e, index) {
      const menuMinWidth = 105
      const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
      const offsetWidth = this.$el.offsetWidth // container width
      const maxLeft = offsetWidth - menuMinWidth // left boundary
      const left = e.clientX - offsetLeft + 15 + this.menuHideleft// 15: margin right

      if (left > maxLeft) {
        this.left = maxLeft
      } else {
        this.left = left
      }

      this.top = e.clientY
      this.visible = true
      this.selectedTag = tag
      this.selectedTagIndex = index
    },
    closeMenu () {
      this.visible = false
    }
  }
}
</script>
<style lang="scss">
@import '@/assets/scss/common.scss';
.tags-view-container {
  width: 100%;
  height: 30px;
  background: #f8f8f8;
  border: 1px solid rgba(230,230,230,1);
  border-bottom: none;
  .tags-view-wrapper {
    .el-tabs__header {
      margin: 0;
    }

    .el-tabs__nav-wrap,
    .el-tabs__nav-scroll {
      overflow: visible;
      height: 30px
    }
   .el-tabs__nav-wrap::after {
     display: none;
   }
    .el-tabs__nav {
      display: flex;
      >div {
        padding: 0;
        height: 29px;
        position: relative;

        &.el-tabs__active-bar {
          display: none;
        }

      }

      .tags-view-item {
         max-width: 98px;
        position: relative;
        user-select: none;
        cursor: pointer;
        height: 30px;
        line-height: 30px;
        color: #29282E;
        background: #EBEBEB;
        padding: 0 8px;
        font-size: 12px;

        &:nth-last-child(1) {
          &::after {
            width: 0;
          }
        }

        &::before,
        &::after {
          content: '';
          width: 1px;
          height: 20px;
          background: #D8D8D8;
          position: absolute;
          top: 5px;
        }

        &::before {
          left: -1px;
        }

        &::after {
          right: 0;
        }

        &.active {
          background-color: #fff;

          &::before {
            width: 0;
          }

          &::after {
            width: 1px;
            right: 0;
            background: #fff;
            z-index: 2;
          }
        }

        .name {
          width: 72px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          display: inline-block;
        }

        .el-icon-close.close {
          width: 11px;
          height: 11px;
          border-radius: 50%;
          text-align: center;
          visibility: hidden;
          color: #fff;
          position: absolute;
          transition: none;
          margin-left: 0;
          top: 10px;
          right: 4px;

          &:before {
            transform: scale(.6);
            display: inline-block;
            position: absolute;
            top: -1px;
            left: -1px;
          }

          &.close-active {
            color: #C2C3C4;
            visibility: visible;
          }
          &:hover {
            background-color: #D9DADA;
             color: #fff;
          }

        }

        .refresh {
          vertical-align: 12px;
          border-radius: 50%;
          text-align: center;
          color: #C4C6C8;
          position: absolute;
          transition: none;
          margin-left: 0;
          right: 4px;
          top: 10px;
          animation: loading 0.5s linear 0s infinite;
          -webkit-animation: loading 0.5s linear 0s infinite;
          -o-animation: loading 0.5s linear 0s infinite;
          -moz-animation: loading 0.5s linear 0s infinite;
        }

        @keyframes loading {
          from {
            transform: rotateZ(0deg);
          }

          to {
            transform: rotateZ(360deg);
          }
        }

        &:hover {
          background: #F6F7F7;

          .el-icon-close {
            visibility: visible;
            color: #C2C3C4;
          }

        }

        &.index {
          width: 67px;
          text-align: center;
          padding-left: 0;
        }

        &.cancle-center {
          width: 100px;
          padding-left: 22px;
        }

      }
      .badge-homepage {
        position: absolute;
        top: 5px;
        right: 18px;
        .el-badge__content{
          background-color: #F77B5B;
        }
      }
      .badge-homepage-more {
        right: 15px;
      }
    }
  }

  .contextmenu {
    background: #fff;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 4px 0px;
    left: 0;
    top: 32px;
    font-size: 10px;
    font-weight: 400;
    color: #29282E;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);
    width: 103px;
    border-radius: 6px;

    li {
      margin: 0;
      font-size: 12px;
      height: 21px;
      padding: 3px 8px ;
      cursor: pointer;
      &:hover {
        background: #EBEBEB;
      }
      &.disabled {
        color:#b1b3b7;
        cursor:default;
        &:hover {
          background: transparent;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/tagsView/index.vue